/**
 * Design note: an initiative title that opens the detail modal (Timeline card hover-popover
 * excluded — that's a different affordance) must always look like this, everywhere it appears:
 * List view, Batch Update, Dependency Log, Scoring. Established 2026-08-08 when Batch Update's
 * title click used a bespoke hover:underline treatment that didn't match Scoring's
 * hover:text-blue-600 (no underline) — pick ONE of the two and use it uniformly instead of
 * letting each view invent its own hover style.
 *
 * Apply this className to the title element itself (not a wrapping row), so hovering
 * specifically over the title text — not just anywhere in the row — is what triggers it.
 */
export const INITIATIVE_TITLE_LINK_CLASS =
  'text-sm font-medium text-text-primary hover:text-blue-600 cursor-pointer';

/**
 * Just the interactive affordance (no typography), for contexts that already have their own
 * deliberate font-size/weight/color — e.g. Dependency Log's nested "depends on X" row is
 * intentionally smaller/lighter than the primary initiative row above it. Use the full
 * INITIATIVE_TITLE_LINK_CLASS instead whenever the base typography would otherwise match it.
 */
export const INITIATIVE_TITLE_LINK_HOVER_CLASS = 'hover:text-blue-600 cursor-pointer';
